import { InkObject } from "./Object";

export class Void extends InkObject {}
